// AdminDashboard.js (React)
import {React, useEffect, useState} from "react";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import Avatar from "./Avatar";
import axios from "axios";
import "./Admin.css"; // Your original CSS file
/* import "../Dashboard/AdminScript" */

const AdminDashboard = () => {

  const navigate = useNavigate();
  useEffect(() => {
    const username = sessionStorage.getItem("username");
    if (!username) {
      navigate("/Signin"); // redirect if not logged in
    }
  }, [navigate]);

  const userName = sessionStorage.getItem("username"); // Replace with dynamic data if needed
  const userID = sessionStorage.getItem("userId")
  const userImage = "https://broken-link.com/avatar.png"; // Replace with real or test URL
  const [counts, setCounts] = useState({
    students: 0,
    tutors: 0,
    demo: 0,
    payments: 0,
  });

  const [todaysClasses, setTodaysClasses] = useState([]);
  const [notifiedClasses, setNotifiedClasses] = useState([]);
  const [istClock, setIstClock] = useState("");

  const fetchCounts = async () => {
    try {
      const [students, tutors, demo, payments] = await Promise.all([
        // axios.get("http://localhost:8000/api/count/students"),
        // axios.get("http://localhost:8000/api/count/tutors"),
        // axios.get("http://localhost:8000/api/count/demo"),
        // axios.get("http://localhost:8000/api/count/payments"),
        axios.get("https://alphabeta4success.com/api/count/students"),
        axios.get("https://alphabeta4success.com/api/count/tutors"),
        axios.get("https://alphabeta4success.com/api/count/demo"),
        axios.get("https://alphabeta4success.com/api/count/payments"),
      ]);
      setCounts({
        students: students.data.count,
        tutors: tutors.data.count,
        demo: demo.data.count,
        payments: payments.data.count,
      });
    } catch (err) {
      console.error(err);
    }
  };

   // Format date header in IST
  const formatISTDate = () =>
    new Date().toLocaleDateString("en-IN", {
      timeZone: "Asia/Kolkata",
      weekday: "long",
      day: "numeric",
      month: "short",
      year: "numeric",
  });

  const handleJoinClass = async (cls) => {
    try {
      //await axios.put("http://localhost:8000/api/tutor/start-class",
      await axios.put("https://alphabeta4success.com/api/tutor/start-class",
        {
          ID: cls.ID,
          meetingId: cls.Meeting_ID,
          tutorId: userID,
        }
      );
  
      // Open the classroom after successful update
      //window.open(
        // `http://localhost:8000/vindex.html?meetingID=${cls.Meeting_ID}&classID=${cls.ID}`,
        // "_blank"
      //);
      window.open(
        `https://alphabeta4success.com/vindex.html?meetingID=${cls.Meeting_ID}&classID=${cls.ID}&UR=${"A"}`,
        "_blank"
      );
    } catch (err) {
      console.error("Failed to update tutor start time:", err);
      alert("Unable to start the class.");
    }
  };

  // Class status based on DB times
  // Convert "HH:MM" string to Date object in IST
const getISTDateTime = (timeStr) => {
  const [hours, minutes] = timeStr.split(":").map(Number);
  const now = new Date();
  
  // Get current date in IST
  const istDate = new Date(
    now.toLocaleString("en-US", { timeZone: "Asia/Kolkata" })
  );

  // Set the hours/minutes of the class
  istDate.setHours(hours, minutes, 0, 0);
  return istDate;
};

// Determine class status based on IST
const getClassStatus = (start, end) => {
  const nowIST = new Date(
    new Date().toLocaleString("en-US", { timeZone: "Asia/Kolkata" })
  );
  const startTime = getISTDateTime(start);
  const endTime = getISTDateTime(end);

  if (nowIST < startTime) return "upcoming";
  if (nowIST >= startTime && nowIST <= endTime) return "ongoing";
  return "past";
};

// Countdown timer in IST
const getCountdown = (start) => {
  const nowIST = new Date(
    new Date().toLocaleString("en-US", { timeZone: "Asia/Kolkata" })
  );
  const startTime = getISTDateTime(start);

  if (nowIST >= startTime) return "Started";

  let diff = (startTime - nowIST) / 1000; // seconds
  const hours = Math.floor(diff / 3600);
  diff %= 3600;
  const minutes = Math.floor(diff / 60);
  //const seconds = Math.floor(diff % 60);

  if (hours === 0) {
    return `Starts in ${minutes}m`;
  } else {
    return `Starts in ${hours}h ${minutes}m`;
  }
 };

  // Sound & alert when class starts
  const checkClassStart = (start, id) => {
    const now = new Date();
    const [h, m] = start.split(":");
    const startTime = new Date();
    startTime.setHours(h, m, 0);

    if (now >= startTime && !notifiedClasses.includes(id)) {
      setNotifiedClasses((prev) => [...prev, id]);
    }
  };

  const isOngoing = (start, end) => getClassStatus(start, end) === "ongoing";

  // Table times (DB values) no conversion
  // Convert "HH:MM" to "hh:mm AM/PM"
  const formatTime = (timeStr) => {
  if (!timeStr) return "";
  const [hourStr, minuteStr] = timeStr.split(":");
  let hour = parseInt(hourStr, 10);
  const minute = parseInt(minuteStr, 10);
  const ampm = hour >= 12 ? "PM" : "AM";
  hour = hour % 12 || 12; // convert 0 -> 12, 13 -> 1, etc.
  return `${hour.toString().padStart(2, "0")}:${minute.toString().padStart(2, "0")} ${ampm}`;
};

  // Fetch data & update IST clock
  useEffect(() => {
    if (!userID) return; // Avoid running until userID exists
    // Fetch today's classes
    const fetchTodaysClasses = async () => {
      try {
        //const response = await axios.get(`http://localhost:8000/api/today-classes/${userID}`);
        const response = await axios.get(`https://alphabeta4success.com/api/today-classes/${userID}`);
        setTodaysClasses(response.data?.data || response.data);
      } catch (err) {
        console.error("Error fetching today's classes:", err);
      }
    };
  
    fetchCounts();
    fetchTodaysClasses();
  
    // Refresh classes every 1 minute
    const classesInterval = setInterval(fetchTodaysClasses, 60000);
  
    // IST clock update
    const clockInterval = setInterval(() => {
      const ist = new Date().toLocaleTimeString("en-IN", {
        hour12: true,
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        timeZone: "Asia/Kolkata",
      });
      setIstClock(ist);
    }, 1000);
  
    return () => {
      clearInterval(classesInterval);
      clearInterval(clockInterval);
    };
  }, [userID]); 
  

  useEffect(() => {
    // Highlight active sidebar item
    const allSideMenu = document.querySelectorAll('#sidebar .side-menu.top li a');
  
    allSideMenu.forEach(item => {
      const li = item.parentElement;
  
      item.addEventListener('click', () => {
        allSideMenu.forEach(i => {
          i.parentElement.classList.remove('active');
        });
        li.classList.add('active');
      });
    });
  
    // Toggle sidebar
    const menuBar = document.querySelector('#sidebar-toggle');
    const sidebar = document.getElementById('sidebar');
  
    const toggleSidebar = () => {
      sidebar?.classList.toggle('hide');
    };
  
    menuBar?.addEventListener('click', toggleSidebar);
  
    // Search toggle
    const searchButton = document.querySelector('#content nav form .form-input button');
    const searchButtonIcon = document.querySelector('#content nav form .form-input button svg');
    const searchForm = document.querySelector('#content nav form');
  
    const handleSearchClick = (e) => {
      if (window.innerWidth < 576) {
        e.preventDefault();
        searchForm?.classList.toggle('show');
      }
    };
  
    searchButton?.addEventListener('click', handleSearchClick);
  
    // Responsive behavior
    const handleResize = () => {
      if (window.innerWidth > 576) {
        searchForm?.classList.remove('show');
      }
    };
  
    window.addEventListener('resize', handleResize);
  
    // Dark mode
    const switchMode = document.getElementById('switch-mode');
    const toggleMode = () => {
      if (switchMode?.checked) {
        document.body.classList.add('dark');
      } else {
        document.body.classList.remove('dark');
      }
    };
  
    switchMode?.addEventListener('change', toggleMode);
  
    // Initial responsive setup
    if (window.innerWidth < 768) {
      sidebar?.classList.add('hide');
    } else if (window.innerWidth > 576) {
      searchForm?.classList.remove('show');
    }
  
    // Cleanup listeners
    return () => {
      menuBar?.removeEventListener('click', toggleSidebar);
      searchButton?.removeEventListener('click', handleSearchClick);
      window.removeEventListener('resize', handleResize);
      switchMode?.removeEventListener('change', toggleMode);
    };
  }, []);
  
  return (
    <div>
      {/* Sidebar */}
      <section id="sidebar">
        <Link to="#" className="brand">
        <img
          src="/Assets/images/AB4S_logo.png"
          alt="AB4S"
          className="sidebar-logo"
        />
        </Link>
        <ul className="side-menu top">
          <li className="active"><Link to="/AdminDashboard"><i className="bx bxs-dashboard"></i><span className="text">Dashboard</span></Link></li>
          <li><a href="https://alphabeta4success.com/action.html" target="_blank"
              rel="noopener noreferrer"><i className="bx bx-video"></i><span className="text">Classroom</span></a></li>
          <li><Link to="#"><i className="bx bx-file"></i><span className="text">File Manager</span></Link></li>
          <li><Link to="/Allocation"><i className="bx bxs-book-content"></i><span className="text">Allocation</span></Link></li>
          <li><Link to="/Scheduler"><i className="bx bxs-calendar-check"></i><span className="text">Re-scheduler</span></Link></li>
          <li><Link to="/UserManagement"><i className="bx bxs-group"></i><span className="text">User Management</span></Link></li>
          <li><Link to="/Contacts"><i className="bx bx-id-card"></i><span className="text">Contacts</span></Link></li>
          <li><Link to="/ResetPassword"><i className="bx bx-message-edit"></i><span className="text">Reset Password</span></Link></li>
          <li><Link to="/Reports"><i className="bx bx-download"></i><span className="text">Reports</span></Link></li>
          <li><Link to="#"><i className="bx bx-calendar-event"></i><span className="text">Calender</span></Link></li>  
        </ul>
        <ul className="side-menu">
          <li><Link to="#"><i className="bx bxs-cog"></i><span className="text">Settings</span></Link></li>
          <li><Link to="/Signin" className="logout"><i className="bx bx-log-out"></i><span className="text">Logout</span></Link></li>
        </ul>
      </section>

      {/* Content */}
      <section id="content">
        <nav>
          <i className="bx bx-menu"></i>
          <h3><span className="highlight-purple">Happy Learning <i className='bx bxs-smile'></i></span></h3>
          {/* <Link to="https://alphabeta4success.com:8000/action.html" className="nav-link">Demo class</Link> */}
          <form>
            <div className="form-input">
              <input type="search" placeholder="Search..." />
              <button type="submit" className="search-btn">
                <i className="bx bx-search"></i>
              </button>
            </div>
          </form>
          <input type="checkbox" id="switch-mode" hidden />
          <label htmlFor="switch-mode" className="switch-mode"></label>
          <div className="topbar-right" style={{ display: "flex", alignItems: "center", gap: 30 }}>
            <span style={{ marginRight: "6px", fontWeight: 600 }}>
              ⏰ -  {istClock} : IST
            </span>
            <span style={{ marginLeft: 8 }}><h3>Welcome, {userName}</h3></span>
            <Avatar name={userName} src={userImage} size={30} className="avatar" />
          </div>
        </nav>

        <main>
          <div className="head-title">
            <div className="left">
              <h2>Dashboard</h2>
              <ul className="breadcrumb">
                <li><Link to="#">Admin</Link></li>
                <li><i className="bx bx-chevron-right"></i></li>
                <li><Link to="#" className="active">Home</Link></li>
              </ul>
            </div>
          </div>

          <ul className="box-info">
          <li>
            <i className="bx bxs-group"></i>
            <span className="text">
              <h3>{counts.students}</h3>
              <p>New Student</p>
            </span>
          </li>
          <li>
            <i className="bx bxs-group"></i>
            <span className="text">
              <h3>{counts.tutors}</h3>
              <p>New Tutor</p>
            </span>
          </li>
          <li>
            <i className="bx bxs-group"></i>
            <span className="text">
              <h3>{counts.demo}</h3>
              <p>Demo</p>
            </span>
          </li>
          <li>
            <i className="bx bxs-dollar-circle"></i>
            <span className="text">
              <h3>{counts.payments}</h3>
              <p>Payment Pending</p>
            </span>
          </li>
        </ul>

        <div className="table-data">
            <div className="order">
              <div className="head">
                <h3>Today's class — {formatISTDate()}</h3>
                <i className="bx bx-search"></i>
                <i className="bx bx-filter"></i>
              </div>
              <table>
                <thead>
                  <tr>
                    <th>Class Time : (IST)</th>
                    <th>Subject</th>
                    <th>Student</th>
                    <th>Class Mode</th>
                    <th>Class Status</th>
                    <th>Class Link</th>
                  </tr>
                </thead>
                <tbody>
                    {todaysClasses.length === 0 ? (
                      <tr>
                        <td colSpan="6" className="no-classes">
                          No classes scheduled today.
                        </td>
                      </tr>
                    ) : (
                      todaysClasses.map((cls) => {
                        const status = getClassStatus(cls.Start_time, cls.End_time);
                        const ongoing = isOngoing(cls.Start_time, cls.End_time);

                        // Sound & popup alert
                        checkClassStart(cls.Start_time, cls.ID);

                        return (
                          <tr
                            key={cls.ID}
                            className={ongoing ? "ongoing-class" : ""}
                          >

                            {/* Class Time */}
                            <td className="class-time-cell">
                              <div className="class-time">
                                {formatTime(cls.Start_time)} - {formatTime(cls.End_time)}
                              </div>

                              {status === "upcoming" && (
                                <div className="class-countdown">
                                  {getCountdown(cls.Start_time)}
                                </div>
                              )}
                            </td>

                            {/* Subject */}
                            <td className="table-center">
                              {cls.Subject}
                            </td>

                            {/* Student */}
                            <td className="table-center">
                              {cls.Student}
                            </td>

                            {/* Class Mode */}
                            <td className="table-center">
                              {status}
                            </td>

                            {/* Class Status */}
                            <td className="table-center">
                              {cls.Meetingstatus}
                            </td>

                            {/* Class Link */}
                            <td className="class-link-cell">
                              {status === "past" ? (
                                <span className="disabled-link">
                                  Completed
                                </span>
                              ) : (
                                <button
                                  className={
                                    status === "upcoming"
                                      ? "upcoming-link"
                                      : "ongoing-link"
                                  }
                                  onClick={() => handleJoinClass(cls)}
                                >
                                  Join
                                </button>
                              )}
                            </td>

                          </tr>
                        );
                      })
                    )}
                  </tbody>
              </table>
            </div>
          </div>
        </main>
      </section>
    </div>
  );
};

export default AdminDashboard;
